<template>
    <div class="modal-content">
        <div class="modal-header border-0 p-4">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 pt-1 mb-0">Włączanie usługi</h2>
            </div>
        </div>
        <page-preloader
            min-height="260px"
            v-if="serviceStatus === 'loading'"
        />
        <div v-else class="modal-body p-4 border-top">
            <div class="c-service__basic row">
                <div class="col-3 d-md-flex d-none justify-content-center">
                    <router-link
                        :to="{
                            name: 'service',
                            params: { id: service.id }
                        }"
                    >
                        <img
                            v-if="service.graphics.smallIconMinioUrl"
                            :src="service.graphics.smallIconMinioUrl"
                            class="c-service__img img-fluid"
                        />
                        <a-icon
                            v-else
                            class="c-service__img text-primary"
                            icon="NoPhoto"
                        />
                    </router-link>
                </div>
                <div class="col-md-9 col-12">
                    <div class="d-flex align-items-center gap-0-5">
                        <div class="d-md-none d-block">
                            <router-link
                                :to="{
                                    name: 'service',
                                    params: { id: service.id }
                                }"
                            >
                                <img
                                    v-if="
                                        service.graphics.smallIconMinioUrl
                                    "
                                    :src="
                                        service.graphics.smallIconMinioUrl
                                    "
                                    class="c-service__imgSmall img-fluid"
                                />
                                <a-icon
                                    v-else
                                    class="c-service__imgSmall text-primary"
                                    icon="NoPhoto"
                                />
                            </router-link>
                        </div>
                        <div>
                            <h2 class="c-service__title">
                                <router-link
                                    :to="{
                                        name: 'service',
                                        params: { id: service.id }
                                    }"
                                >
                                    {{ service.name }}
                                </router-link>
                            </h2>
                            <p class="c-service__status" v-if="allShops">
                                Aktywujesz we
                                <strong>wszystkich</strong>
                                sklepach
                            </p>
                            <p class="c-service__status" v-else>
                                Aktywujesz w
                                <strong>
                                    {{ selectedShopIds.length }} z
                                    {{ subscriptions.length }}
                                </strong>
                                sklepach
                            </p>
                        </div>
                    </div>

                    <div
                        class="v-service__shoplist t-shops"
                        v-if="!allShops"
                    >
                        <div class="custom-checkbox mb-2">
                            <the-btn
                                text="Zaznacz wszystkie"
                                class="btn-outline-custom d-none d-sm-inline-flex"
                                :class="{
                                    'd-inline-flex': !allowSelectAll
                                }"
                                icon="CheckCorrect"
                                @click.native="selectAllShops(true)"
                            />
                            <the-btn
                                text="Odznacz wszystkie"
                                class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
                                :class="{ 'd-inline-flex': allowSelectAll }"
                                icon="CheckIncorrect"
                                @click.native="selectAllShops(false)"
                            />
                        </div>
                        <service-shop
                            v-for="(shop, idx) in subscriptions"
                            :key="idx"
                            :shop="shop"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer d-block">
            <div
                class="c-service__legal"
                v-if="serviceStatus !== 'loading'"
            >
                <p v-if="service.code === 'pp_ms'" class="c-service__clause text-muted">
                    Administratorem Pani/Pana danych osobowych jest Eurocash
                    Sieci Partnerskie Sp. z o.o. z siedzibą w Komornikach
                    (62-052) przy ul. Wiśniowej 11.
                    <span
                        class="c-service__showMore cursor-pointer"
                        :class="{ 'show': !showInformationClause }"
                        @click="showInformationClause = !showInformationClause"
                    >
                        CZYTAJ WIĘCEJ...
                    </span>
                    <span
                        class="c-service__more"
                        :class="{ 'hidden': !showInformationClause }"
                    >
                        Podane przez Panią/Pana dane osobowe przetwarzane będą w celu
                        realizacji usług Powszechnego Towarzystwa Promocyjnego M/Sklepy,
                        w tym dokonywania rozliczeń z tytułu świadczonych usług oraz z
                        tytułu wykorzystanych promocji, dokonywania rozliczeń podatkowych,
                        rozpatrywania reklamacji oraz do dochodzenia lub obrony przed
                        roszczeniami, a w przypadku wyrażenia zgody marketingowej, w celu
                        przesyłania wiadomości marketingowych o promocjach dostępnych na
                        EuroPlatform. Zgodę można wycofać w każdym czasie. Wycofanie zgody
                        nie ma wpływu na zgodność z prawem przetwarzania dokonanego przed jej
                        wycofaniem. Pełna informacja o przetwarzaniu danych osobowych jest
                        dostępna
                        <a
                            class="text-primary"
                            target="_blank"
                            :href="informationClausePath"
                        >
                            TUTAJ
                        </a>.
                        <span
                            class="c-service__showLess cursor-pointer text-primary"
                            :class="{ 'show': showInformationClause }"
                            @click="showInformationClause = !showInformationClause"
                        >
                            Zwiń
                        </span>
                    </span>
                </p>
                <p class="c-service__legalDiclamer text-primary">
                    Aktywując usługę oświadczam, iż zapoznałem się z
                    załącznikami i akceptuję ich treść.
                </p>

                <ul class="v-service__documentList pl-3 mb-0">
                    <li v-for="(file, idx) in service.documents" :key="idx">
                        <a
                            class="v-service__link"
                            target="_blank"
                            :href="file.minioUrl"
                        >
                            <a-icon
                                style="min-width: 24px;"
                                icon="Download"
                            />
                            <span class="v-service__documentName text-sm">
                                {{ file.name }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="modal-footer__btnWide">
                <button
                    type="button"
                    class="btn btn-outline"
                    :class="{ disabled: status === 'loading' }"
                    data-dismiss="modal"
                    @click="closeModal"
                >
                    Zamknij
                </button>
                <button
                    v-if="allShops"
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="activateShops(true)"
                >
                    Włącz usługę we wszystkich sklepach
                    <button-spinner
                        class="ml-3"
                        :status="status"
                    />
                </button>
                <button
                    v-else
                    :disabled="!selectedShopIds.length"
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="activateShops(false)"
                >
                    Włącz usługę
                    <button-spinner
                        class="ml-3"
                        :status="status"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceShop from '@/components/services/ServiceShop'

export default {
    data() {
        return {
            status: 'idle',
            showInformationClause: false
        }
    },
    components: {
        ServiceShop
    },
    methods: {
        closeModal() {
            if (this.status === 'loading') return
            this.$store.dispatch('toggleModal', false)
        },
        async activateShops(value) {
            if (this.status === 'loading') return
            let shopIds = []
            this.status = 'loading'
            if (
                this.service.level !== 'User' &&
                this.service.level !== 'Company'
            ) {
                shopIds = value
                    ? this.$store.getters.getAllServiceShopIds
                    : this.$store.getters.getToActiveServiceShopIds
            }

            await this.$store.dispatch('serviceActivate', {
                serviceId: this.service.id,
                serviceCode: this.service.code,
                shopIds: shopIds,
                allShops: value,
                level: this.service.level,
                singleService: this.modalState.args.singleService
            })
            this.status = 'idle'
            if (this.service.code === 'pp_ms' && !this.modalState.args.singleService) {
                this.$store.dispatch('consentsFetch')
                this.$store.dispatch('openModal', {
                    component: 'ConsentsModal',
                    args: {
                        consentCode: 'ECSP',
                        hideConsentDetails: true
                    }
                })
            }
        },
        selectAllShops(value) {
            const subscriptions = this.service.subscriptions.map(el => {
                if (el.status === 'inactive') {
                    return {
                        ...el,
                        checked: value
                    }
                } else {
                    return el
                }
            })
            this.$store.dispatch('setService', {
                ...this.service,
                subscriptions
            })
            this.$store.dispatch('selectServiceShops', subscriptions)
        }
    },
    computed: {
        fetchService() {
            return this.modalState.args.fetchService
        },
        modalState() {
            return this.$store.getters.modalState
        },
        allShops() {
            return this.modalState.args.allShops
        },
        selectedShopIds() {
            return this.$store.getters.getToActiveServiceShopIds
        },
        service() {
            return !this.allShops
                ? this.$store.getters.getService
                : this.modalState.args.service
        },
        serviceStatus() {
            return this.$store.getters.getServiceStatus
        },
        subscriptions() {
            return this.service.subscriptions.filter(
                el => el.status === 'inactive'
            )
        },
        isCheckedAllInactive() {
            return this.modalState.args.isCheckedAllInactive
        },
        allowSelectAll() {
            return this.service.subscriptions
                .filter(el => el.status === 'inactive')
                .every(el => el.checked)
        },
        informationClausePath() {
            return this.service.documents.find(
                v => v.name === 'Klauzula informacyjna dotycząca danych osobowych'
            )?.minioUrl
        }
    },
    async created() {
        if (this.fetchService) {
            await this.$store.dispatch(
                'serviceFetch',
                this.modalState.args.service.id
            )
        }
    },
    watch: {
        serviceStatus: {
            immediate: true,
            handler(val) {
                if (
                    val === 'idle' &&
                    this.service.subscriptions &&
                    this.isCheckedAllInactive &&
                    !this.allShops
                ) {
                    this.selectAllShops(true)
                }
            }
        }
    },
    beforeDestroy() {
        if (this.isCheckedAllInactive && !this.allShops) {
            this.selectAllShops(false)
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    max-width: 100%;
}
</style>
